import Vue from "vue";
import OwnerReportRepository from "@/repositories/report/OwnerReportRepository";
import _ from "lodash";
import store from "@/store";

export interface PowerBiReport {
    uuid: string;
    label: string;
    token?: string;
    icon?: string;
    module: string;
    reportUuid?: string;
    linkReports?: string;
    userSyncRequired?: boolean;
    agentAiAccess: boolean;
    agentAiMcpAccess: boolean;
}

export default {
    state: {
        ownerReports: {
        },
    },
    mutations: {
        setOwnerReports: (state: any, reports: PowerBiReport[]) => {
            Vue.set(state, "ownerReports", reports);
        },
    },
    getters: {
        getOwnerReports: (state: any): PowerBiReport[] => {
            return state.ownerReports;
        },
    },
    actions: {
        loadOwnerReports: ({ commit }: any) => {
            OwnerReportRepository.get({
                filters: {
                    ownerUuid: _.get(store, "getters.getCurrentOwner", "").uuid
                }
            }).then((data: any) => {
                commit("setOwnerReports", data);
            });
        }
    },
};
